import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { Column, ColumnProps } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { RefObject } from "react";
import { RouterProps } from "react-router";
import { Flex } from "reflexbox";
import ReactFileReader from 'react-file-reader';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import _ from "lodash";
import { Observable } from "rxjs";
import { Link } from "react-router-dom";

import { DataSource } from "../../models/DataSource";
import { DataTableFilterService } from "../../services/DataTableFilterService";
import { MonitoringRestService } from "../../services/MonitoringRestService";
import { DependencyContainer } from "../../utils/DependencyInjection";
import {
  IMonitoringFeeFilterContainerValue,
  MonitoringFeeFilterContainer,
} from "./MonitoringFeeFilterContainer";
import qs from "qs";
import { reaction } from "mobx";

export interface IMonitoringFeeContainerQuery {
  filters: IMonitoringFeeFilterContainerValue;
}

@observer
export class MonitoringFeeContainer extends React.Component<RouterProps, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  growl;
  tableExportData;
  userData;
  dataSource = new DataSource<any>();
  formFilters: IMonitoringFeeFilterContainerValue;
  refFilter: RefObject<MonitoringFeeFilterContainer> = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      showExportDialog: false,
      showDialog: false,
      buttonCsv: true,
      dataList: [],
      dataRepresentativeUser: null,
      dataBranchUser: null,
      showFilter: true,
    };

    this.userData = localStorage.getItem("userData")
      ? JSON.parse(localStorage.userData)
      : null;

    this.exportCsv = this.exportCsv.bind(this);
  }

  componentDidMount() {
    let branchCode: any = localStorage.getItem("branchCode");
    if (branchCode) {
      this.monitoringRestService.get("monitoring-penalty/branch/data/" + branchCode).subscribe(
        (response) => {
          if (response.length > 0) {
            this.setState({
              dataRepresentativeUser: response[0].representative_id,
              dataBranchUser: response[0].branch_id,
              showFilter: false,
            });
          }
        },
        () => {
          this.dataSource.loading = false;
        },
        () => {
          this.dataSource.loading = false;
        }
      );
    } else {
      this.setState({
        dataRepresentativeUser:'',
        dataBranchUser: '',
        showFilter: true,
      });
    }
  }

  loadData() {
    this.formFilters = this.refFilter.current!.formValues;

    if (!this.state.showFilter) {
      this.formFilters.perwakilan = this.state.dataRepresentativeUser;
      this.formFilters.branch = this.state.dataBranchUser;
    }

    if (this.formFilters.perwakilan === '') {
      let msg = {
        severity: "error",
        summary: "Filter Message",
        detail: "Perwakilan harus diisi",
      };
      this.growl.show(msg);
    } else {

      this.monitoringRestService.post("monitoring-penalty/list", this.formFilters).subscribe(
        (response) => {
          this.setState({
            dataList: response,
          });
          if (response.length === 0) {
            let msg = {
              severity: "error",
              summary: "Info Message",
              detail: "Data Tidak Ditemukan",
            };
            this.growl.show(msg);
          }
        },
        () => {
          this.dataSource.loading = false;
        },
        () => {
          this.dataSource.loading = false;
        }
      );
    }
  }

  columnListTable() {
    let rowHtml: any[] = [];
    this.state.dataList.forEach(element => {
      rowHtml.push(
        <tr>
          <td style={{height: '30px', textAlign: 'center', border: '1px solid grey', borderCollapse: 'collapse'}}>
            {element.representative_name} ({element.representative_code})
          </td>
          <td style={{height: '30px', textAlign: 'center', border: '1px solid grey', borderCollapse: 'collapse'}}>
            {element.branch_name}
          </td>
          <td style={{height: '30px', textAlign: 'center', border: '1px solid grey', borderCollapse: 'collapse'}}>
            <Link
              to={{
                pathname: "/admin/monitoring/pod-fee/detail",
                search: qs.stringify({
                  representativeId: element.representative_id,
                  branchId: element.branch_id,
                  filters: this.formFilters,
                }),
              }}
            >
              {element.total_penalty}
            </Link>
          </td>
        </tr>
      );
    });
    return rowHtml;
  }

  exportCsv() {
    this.tableExportData.exportCSV();
    let msg = {
      severity: "success",
      summary: "Success Message",
      detail: "Export Success",
    };
    this.growl.show(msg);
  }

  render() {
    return (
      <div>
        <Dialog
          header="Informasi"
          visible={this.state.showExportDialog}
          style={{ width: "40vw" }}
          modal={true}
          onHide={() => this.setState({ showExportDialog: false })}
        >
          Export excel sedang berjalan, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Dialog header="Informasi" visible={this.state.showDialog} style={{ width: '40vw' }} modal={true} onHide={() => this.setState({ showDialog: false })}>
          Sedang memuat data, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Growl ref={(el) => (this.growl = el)} style={{ marginTop: "75px" }} />

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <MonitoringFeeFilterContainer ref={this.refFilter} showFilter={this.state.showFilter}/>
            <br />
            <Flex>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                onClick={() => this.loadData()}
              />
              <Button
                type="button"
                className="p-button-primary mr-2"
                icon="pi pi-external-link"
                iconPos="left"
                label="CSV"
                onClick={this.exportCsv}
                disabled={this.state.buttonCsv}
              ></Button>
            </Flex>
          </Flex>
        </Flex>

        {
          this.state.dataList.length > 0 &&
          (
            <Flex className="card w-full">
              <Flex className="w-full" column>
              <div className="col-md-12">
                <table style={{width: '100%', border: '1px solid grey', borderCollapse: 'collapse'}}>
                  <tr style={{height: '50px', backgroundColor: '#d03731', color: 'white'}}>
                    <th style={{width: '33%', textAlign: 'center'}}>
                      Perwakilan
                    </th>
                    <th style={{width: '33%', textAlign: 'center'}}>
                      Cabang
                    </th>
                    <th style={{width: '33%', textAlign: 'center'}}>
                      Jumlah Denda
                    </th>
                  </tr>
                  {this.columnListTable()}
                </table>
              </div>
              </Flex>
            </Flex>
          )
        }
      </div>
    );
  }
}
